import {IDirective, INgModelController, IParseService, IScope} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";

export function valideringsuttrykkInjisering() {
    return [regNavn.ng.$parse, valideringsuttrykk]
}

/**
 * Direktiv for å registrere valideringsuttrykk på ng-model.
 * Feil vil bli registrert under nøkkelen 'valideringsuttrykk'
 */
export function valideringsuttrykk($parse:IParseService): IDirective {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: ($scope: IScope, $elem, $attrs: any, ctrl: INgModelController) => {
            var expr = $attrs.valideringsuttrykk;
            var watches = $attrs.valideringsuttrykkWatch;

            ctrl.$validators.valideringsuttrykk = function (modelValue, viewValue) {
                return expr == undefined || (angular.isString(expr) && expr.length < 1) || $parse(expr)($scope, { $model: modelValue, $view: viewValue }) === true;
            };

            if (angular.isString(watches)) {
                angular.forEach(watches.split(",").filter(function (n) { return !!n; }), function (n) {
                    $scope.$watch(n, function () {
                        ctrl.$validate();
                    });
                });
            }

        }
    }
}

